import { render, staticRenderFns } from "./NewsDetailPage.vue?vue&type=template&id=3e709a23"
import script from "./NewsDetailPage.vue?vue&type=script&lang=js"
export * from "./NewsDetailPage.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailPage.vue?vue&type=style&index=0&id=3e709a23&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports